import {Button, Input, Switch} from 'antd';
import {AsyncSwitch, CrudForm, CrudFormItemProps} from 'digimuth-components/dist';
import React from "react";

const layout = {
    labelCol: {span: 8},
    wrapperCol: {xs: 24, md: 12},
};

const tailLayout = {
    wrapperCol: { xs: {offset: 0, span: 4}, md: { offset: 8, span: 4 } },
};

const formItems: CrudFormItemProps[] = [{
    label: "Email",
    name: "email",
    rules: [{required: true, message: 'To pole jest wymagane'}]
}, {
    label: "Hasło",
    name: "password",
    rules: [{required: true, message: 'To pole jest wymagane'}],
    children: <Input.Password/>
}, {
    label: "Zapamiętaj mnie",
    name: "rememberMe",
    children: <AsyncSwitch/>
}];

export default function Login(props: LoginProps) {
    const initValues = {
        "Input.RememberMe": false
    };

    return <CrudForm
        onSubmit={props.onLogin}
        formItems={formItems}
        initialValues={initValues}
        saveButtonTitle="Zaloguj"
        formProps={layout}
        tailProps={tailLayout}
        extraActions={<Button type="link" onClick={props.onForgotPassword}>Zapomniałeś hasła?</Button>}/>
}

interface LoginProps {
    onLogin: (value: LoginViewModel) => Promise<boolean>,
    onForgotPassword: () => any
}

export interface LoginViewModel {
    username: string,
    password: string,
    rememberMe: boolean
}
